module.exports = __webpack_public_path__ + "static/media/socialPiper-budget-tablet-es.42186664.png";